import { useState, useRef } from "react";
import AtomH2 from "Components/Atoms/H2";
import AtomSubtitle2 from "Components/Atoms/Subtitle2";
import AtomDescription1 from "Components/Atoms/Description1";

import AtomNowThumbnail from "Components/Atoms/NowList/Thumbnail";
import styled, { css } from "styled-components";

import * as Types from "Types";

export interface NowContent extends Types.Default {
   title: string;
   thumbnail_uri: string;
   subtitles: string;
   description: string;
}

const Wrap = styled.div<Types.Default>`
   display: flex;
   flex-direction: row;
   column-gap: 105px;
   position: relative;
   padding: 30px 10px 30px 10px;
   border-bottom: 1px solid rgba(0, 0, 0, 0.1);
   ${({ css }) => css}
`;

const Child1Wrap = styled.div``;

const ChildThumbnail = styled(AtomNowThumbnail)`
   width: 240px;
   box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
`;

const Child2Wrap = styled.div``;
const Child2Wrap2 = styled.div``;

const ChildTitle = styled(AtomH2)`
   line-height: 39px;
   margin-bottom: 17px;
`;

const ChildSubtitle = styled(AtomSubtitle2)`
   line-height: 22px;
   margin-bottom: 6px;
`;

const ChildDescription = styled(AtomDescription1)`
   line-height: 23px;
   margin-top: 18px;
`;

function NowList(props: NowContent) {
   const subtitles = JSON.parse(props.subtitles);
   const wrapRef = useRef(null);
   const [descriptionLinePerRows, setDescriptionLinePerRows] = useState(4);

   function ThumbnailOnLoad(ev: any) {
      const height = ev.target.height;
      const gap = height - ((wrapRef.current && (wrapRef.current as HTMLDivElement).offsetHeight) || 0);

      if (Math.floor(gap / 23) > 0) {
         console.log("4 + Math.floor(gap / 23)", 4 + Math.floor(gap / 23));
         setDescriptionLinePerRows(4 + Math.floor(gap / 23));
      } else {
         console.log("row false");
      }
   }

   return (
      <Wrap css={props.css}>
         <Child1Wrap>
            <ChildThumbnail onLoad={ThumbnailOnLoad} src={props.thumbnail_uri}></ChildThumbnail>
         </Child1Wrap>
         <Child2Wrap>
            <Child2Wrap2 ref={wrapRef}>
               <ChildTitle>{props.title}</ChildTitle>
               {subtitles.map((subtitle: any) => (
                  <ChildSubtitle key={subtitle.key}>
                     {subtitle.key} : {subtitle.content}
                  </ChildSubtitle>
               ))}
               <ChildDescription
                  css={css`
                     -webkit-line-clamp: ${descriptionLinePerRows};
                     display: -webkit-box;
                     -webkit-box-orient: vertical;
                     word-wrap: break-word;
                     text-overflow: ellipsis;
                     overflow: hidden !important;
                  `}>
                  {props.description}
               </ChildDescription>
            </Child2Wrap2>
         </Child2Wrap>
      </Wrap>
   );
}

export default NowList;
